module.exports = __webpack_public_path__ + "static/media/018-Verlassen_ID_2.b9a5ab26.mp3";